import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NoteService } from 'src/app/shared/services/note.service';
import { ApprovalPath } from 'src/app/shared/models/approval-path.model';
import { Router, ActivatedRoute } from '@angular/router';
import { Note } from 'src/app/shared/models/note.model';

@Component({
  selector: 'app-modal-note',
  templateUrl: './note-modal.component.html'
})
export class ModalNoteComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() approvalPath: ApprovalPath;
  @Output() onSubmited = new EventEmitter<Note[]>();

  newNoteFormGroup: FormGroup;

  constructor(
    private noteService: NoteService,
    private toastrService: ToastrService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.createFormGroup();
  }

  createFormGroup() {
    this.newNoteFormGroup = this.fb.group({
      note: [null, [Validators.required]]
    });
  }

  submit() {
    this.noteService.createApprovalPathNote(this.newNoteFormGroup.get('note').value, this.approvalPath.id).subscribe((response: Note[]) => {
      this.toastrService.success('Twoja uwaga została zapisana.');
      const routeParams = this.activeRoute.snapshot.params;
      if (routeParams) {
        this.router.navigate(['cost/', routeParams.id], { fragment: 'notes' });
      }
      this.onSubmited.emit(response);
      this.close();
    });
  }

  open() {
    this.isVisible = true;
  }

  close() {
    this.newNoteFormGroup.reset();
    this.isVisible = false;
  }

}
